import {useGetSport} from '@/common/useGetSport';
import {useEffect} from 'react';
import {logAnalyticsEvent} from '../../../common/analytics-events';
import {useLogout} from '../../../hooks/useLogout';

export const FkoRestart = () => {
  const {logout} = useLogout();
  const {basePath, fkoAnalyticsPrefix} = useGetSport();

  useEffect(() => {
    logAnalyticsEvent(`${fkoAnalyticsPrefix}_restart`);
    logout(basePath);
  }, [basePath, fkoAnalyticsPrefix, logout]);

  return null;
};
